import { render, staticRenderFns } from "./plan-fields.vue?vue&type=template&id=28365c08"
import script from "./plan-fields.vue?vue&type=script&lang=js"
export * from "./plan-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports